import React, { useEffect, useState } from "react";
import AuthUser from "../../services/AuthUser";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import CircularScrollProgress from "../Circularprogress";
import CitySelector from "./CitySelectore";
import ProfileSection from "../Agent/ProfileSection";






const Profile = () => {
  const [user, setUser] = useState({
    name: "",
    city: "",
    mobile: "",
    email: "",
  });
  const [profile, setProfile] = useState({

  });

       const { http, token } = AuthUser();


  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUser(storedUser);
      setProfile(storedUser);
    }
  }, []);
  

  

  // ✅ Modal open handler
  const openEditModal = (selectedUser) => {
    setUser({
      name: selectedUser.name,
      mobile: selectedUser.mobile || "",
      email: selectedUser.email,
      user_id: selectedUser.user_id,
    });
    setShowModal(true);
  };
  
  const closeModal = () => {
    setShowModal(false);
  };
  
  // ✅ Update user handler
  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const response = await http.put(`/update-user/${storedUser.id}`, {
        name: user.name,
        mobile: user.mobile,
        city: user.city,
       
      });
  
      if (response.data && response.data.status) {
        console.log("User updated:", response.data);
  
        // ✅ Update localStorage and state
        localStorage.setItem("user", JSON.stringify(response.data.user));
        setUser(response.data.user);
        setProfile(response.data.user);
  
        // ✅ Show success alert
        alert("✅ User updated successfully.");
  
        // ✅ Close modal
        setShowModal(false);
      } else {
        alert("⚠️ Unexpected response format.");
      }
    } catch (error) {
      console.error("Error updating user:", error);
  
      // ✅ Show error from Laravel validation if exists
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = Object.values(error.response.data.errors)
          .flat()
          .join("\n");
        alert(`❌ Update failed:\n${errorMessages}`);
      } else {
        alert("❌ Something went wrong while updating.");
      }
    }
  };
  

  // ✅ Utility




  return (
    <div>
      <div className="container mt-4">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card shadow-sm">
              <div className="card-body bg-light">
                {/* Profile Top Section */}
                <div className="pro-top d-flex">
             <ProfileSection/>

                  <div className="pro d-flex flex-column justify-content-center mx-4">
                    <h4 className="mb-2 font-weight-bold">{profile.name}</h4>
                    <p className="text-muted">
                      Joined on {new Date(profile.created_at).toLocaleDateString()}
                    </p>
                  </div>
                </div>

                <hr />

                {/* Profile Details */}
                <div className="row">
                  <div className="col-md-12">
                    <h5 className="font-weight-bold">Profile Details</h5>
                    <hr />
                    <div className="row mx-auto">
                      <div className="col-md-6 mb-4">
                        <strong>Name</strong>
                      </div>
                      <div className="col-md-6 mb-4 text-capitalize">{profile.name}</div>
                      <div className="col-md-6 mb-4">
                        <strong>User ID</strong>
                      </div>
                      <div className="col-md-6 mb-4 ">{profile.user_id}</div>

                      <div className="col-md-6 mb-4">
                        <strong>Mobile</strong>
                      </div>
                      <div className="col-md-6 mb-4">{profile.mobile}</div>

                      <div className="col-md-6 mb-4">
                        <strong>Email ID</strong>
                      </div>
                      <div className="col-md-6 mb-4 ">{profile.email}</div>
                      <div className="col-md-6 mb-4">
                        <strong>City</strong>
                      </div>
                      <div className="col-md-6 mb-4 text-capitalize">{profile.city}</div>



                    </div>

                    <div className="text-center mt-4">
                      {/* Edit button */}
                      <button className="btn btn-danger px-4" onClick={() => openEditModal(user)}>
                        EDIT
                      </button>


                    </div>
                    {showModal && (
                      <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog" role="document">
                          <form onSubmit={handleUpdateUser}>
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Edit Profile</h5>
                                <button type="button" className="btn-close" onClick={closeModal}>
                          
                                </button>
      
                              </div>

                              <div className="modal-body">
                                <div className="form-group">
                                  <label>Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={user.name}
                                    onChange={(e) => setUser({ ...user, name: e.target.value })}
                                    required
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Mobile</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={user.mobile}
                                    onChange={(e) => setUser({ ...user, mobile: e.target.value })}
                                  />
                                </div>

                           
                                <CitySelector
                                          newData={user}
                                          setNewData={setUser}
                                          fieldKey="city"
                                          errors={''}
                                       />

                              </div>

                              <div className="modal-footer">
                                <button className="btn btn-primary" type="submit">Save changes</button>
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}


                  </div>
                </div>
              </div>
            </div>

            {/* Documents Section (Grid View) */}
         



          </div>
        </div>
      </div>
      <div className="space40 bg-white"></div>
      <WhatsAppScrollButton />
      <Footer />
      <CircularScrollProgress />
    </div>
  );
};

export default Profile;
